import { writable as svelteWritable, readable as svelteReadable, derived as svelteDerived, get } from "svelte/store";
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */
export function readable(value, start) {
    const store = svelteReadable(value, start);
    store.get = () => get(store);
    return store;
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */
export function writable(value, start) {
    const store = svelteWritable(value, start);
    store.get = () => get(store);
    return store;
}
/**
 * Derived value store by synchronizing one or more readable stores and
 * applying an aggregation function over its input values.
 *
 * @param stores - input stores
 * @param fn - function callback that aggregates the values
 */
export function derived(stores, fn) {
    const store = svelteDerived(stores, fn);
    store.get = () => get(store);
    return store;
}
